import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import 'react-select/dist/react-select.css'
import 'react-virtualized-select/styles.css'
import Select from "react-virtualized-select";
import donwload from "../../../../../resources/donwload.png";
import Tooltip from '@material-ui/core/Tooltip';
import PDF from "./pdf.js";
import axios from "axios";
import { saveAs } from "file-saver";
import { Col, Row } from "reactstrap";
import { withNamespaces } from "react-i18next";

// import Select from "react-select";

/*=============================================
=            reportes             =
=============================================*/
class Contenedores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      catalog: [
        {
          key: "contenedoresaereos",
          value: "contenedoresaereos",
          label: this.props.t("air_freight_container"),
          uri: this.props.t("air_freight_container_img"),
          donwloadpdf: this.props.t("air_freight_container_dowloand_pdf"),
          namepdf: `${this.props.t("air_freight_container")}.pdf`
        },
        {
          key: "Contenedoresmaritimos",
          value: "Contenedoresmaritimos",
          label: this.props.t("ocean_freight_container"),
          uri: this.props.t("ocean_freight_container_img"),
          donwloadpdf: this.props.t("ocean_freight_container_dowloand_pdf"),
          namepdf: `${this.props.t("ocean_freight_container")}.pdf`
        },
        {
          key: "Mercanciapeligrosa",
          value: "Mercanciapeligrosa",
          label: this.props.t("dangerous_goods"),
          uri: this.props.t("dangerous_goods_img"),
          donwloadpdf: this.props.t("dangerous_goods_dowloand_pdf"),
          namepdf: `${this.props.t("dangerous_goods")}.pdf`
        },
        {
          key: "Pesobrutomaximo",
          value: "Pesobrutomaximo",
          label: this.props.t("max_gross_weight"),
          uri: this.props.t("max_gross_weight_img"),
          donwloadpdf: this.props.t("max_gross_weight_dowloand_pdf"),
          namepdf: `${this.props.t("max_gross_weight")}.pdf`
        },
        {
          key: "Pallets",
          value: "Pallets",
          label: this.props.t("pallets"),
          uri: this.props.t("pallets_img"),
          donwloadpdf: this.props.t("pallets_dowloand_pdf"),
          namepdf: `${this.props.t("pallets")}.pdf`
        },
        {
          key: "Especificacionesdeunidades",
          value: "Especificacionesdeunidades",
          label: this.props.t("units_specs"),
          uri: this.props.t("units_specs_img"),
          donwloadpdf: this.props.t("units_specs_dowloand_pdf"),
          namepdf: `${this.props.t("units_specs")}.pdf`
        },

      ],
      value: "contenedoresaereos",
      img: this.props.t("air_freight_container_img"),
      donwloadpdf: this.props.t("air_freight_container_dowloand_pdf"),
      namepdf: `${this.props.t("air_freight_container")}.pdf`
    };
  }

  componentDidMount = () => { };

  Onchange = (value) => {
    let newValue = value.key;
    let newImg = value.uri;
    let donwloadpdf = value.donwloadpdf;
    let namepdf = value.namepdf;
    this.setState({
      value: newValue,
      img: newImg,
      donwloadpdf: donwloadpdf,
      namepdf: namepdf
    });
  };

  descarga = (uri) => {
    // const linkSource = `data:application/pdf;base64,${PDF}`;
    // const downloadLink = document.createElement("a");
    // // const fileName = 'REPORT_COST_' + new Date() + '.xlsx';
    // const fileName = "ContenedoresSCL.pdf";
    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
    // this.setState({
    //   loading: false,
    // })

    let { donwloadpdf, value, namepdf } = this.state;
    const linkSource = donwloadpdf;
    this.setState({
      loading: false,
    })
    axios({
      method: 'get',
      url: encodeURI(linkSource),
      responseType: 'blob'
    }).then(function (response) {
      saveAs(
        response.data,
        `${namepdf}`
      );
    }).catch(function (error) {
      console.log(error);
      console.log('download error');
    });
  };



  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  render() {
    let { catalog, value, img, loading } = this.state;
    console.log("loading", loading);
    return (
      <>
        <Col xs={12} md={12} lg={12}>
          {/* <div className="col-xs-12 col-md-12 col-lg-12 row"> */}
          {/* <div style={{ marginBottom: "5em", display: "flex", alignItems: "center"}} className='col-12 row'> */}
          <Row>
            {/* <Col xs={12} md={3} lg={3}>
              <label className="subtitlecontenedor">
                Seleccionar el tipo de contenedores
              </label>

            </Col> */}

            <div className="col-xs-10 col-md-5 col-lg-5">
              <Select
                style={{
                  color: "#323C47",
                  fontSize: "12px",
                }}
                placeholder=""
                value={value}
                options={catalog}
                clearable={false}
                onChange={(value) => this.Onchange(value)}
              />
            </div>
            <div className="col-xs-2 col-md-5 col-lg-5">
              {loading ? (
                // <center>
                // {" "}
                <Icon
                  loading={loading}
                  // style={{ marginTop: "9px" }}
                  name="circle notch"
                  size="large"
                />
                // </center>
              ) : (
                // <center>

                <img
                  onClick={() => {
                    this.setState({
                      loading: true,
                    }, () => {
                      this.sleep(1000).then(() => {
                        this.descarga(donwload);
                      });
                    })
                  }}
                  style={{ margin: "6px", marginTop: "-1px", cursor: "pointer" }}
                  alt=""
                  title={this.props.t("download_pdf")}
                  src={'https://magiclog.blob.core.windows.net/europartnerspic/pdficon.png'}
                  width="35"
                  height="35"
                ></img>
                // <Tooltip open={true} interactive={true} title="Descargar todos los contenedores" placement="placement" >
                // </Tooltip>
                // </center>
              )}
              {/* </div> */}
              <br></br>
              <br></br>
            </div>
          </Row>
          {/* </div> */}
          <div className="divcenter col-12">
            <Col xs={12} md={8} lg={8}>
              <img
                // style={{ margin: "6px", marginTop: "-1px" }}
                alt=""
                src={img}
                width="100%"
              ></img>
            </Col>
          </div>


          {/* </div> */}
        </Col>
      </>
    );
  }
}

export default withNamespaces()(Contenedores);
